<template>
  <div class="field-input" >
    <div>
    
    </div>
    <div id="inputBox"><input type='text' placeholder="Enter a New Field" class='field-new' @keydown.enter='addTag' @keydown.188='addTag'></div>
    <div v-for='(field, index) in fields' :key='field' class='existing-field'>
      <span style="backgound-color: " @click='removeField(index)'>x</span>
      {{ field }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'EventFieldInput',
  props: ["fields"],
  methods: {
    addTag(event) {
      event.preventDefault();
      var val = event.target.value.trim();
      if (val.length > 0) {
        this.$emit('add-field', val);
        event.target.value = '';
      }
    },
    removeField(index) {
      this.$emit('remove-field', index);
    }
  }
}
</script>

<style scoped>
.field-input {
  width: 100%;
  font-size: 0.9em;
  height: 50px;
  box-sizing: border-box;
  padding: 0 10px;
  
  margin-top: 10px;
}

.existing-field {
  height: 30px;
  float: left;
  margin-right: 10px;
  background-color: var(--form-blue);;
  color: white;
  margin-top: 10px;
  line-height: 30px;
  padding: 0 5px;
  border-radius: 5px;
  font-weight: 500;
  
}

.existing-field > span {
  cursor: pointer;
  opacity: 0.75;
}

.field-new {
  text-align: left;
  outline: none;
}

#inputBox{
  text-align: left;
}
</style>
